export default __webpack_public_path__ + "static/media/people-icon_.f8f4ced1.svg";